module.exports = __webpack_public_path__ + "img/orange-lily.9d6c2523.jpg";